import { RootState } from "@store";
import { useSelector } from "react-redux";

export const usePoolTemplates = () => {
  return useSelector((state: RootState) => state.poolTemplates.templates);
};
